/**
 * @fileOverview Scratch Audio is divided into a single AudioEngine, that
 * handles global functionality, and AudioPlayers, belonging to individual
 * sprites and clones.
 */

const AudioEngine = require('./AudioEngine');

module.exports = AudioEngine;



//////////////////
// WEBPACK FOOTER
// ./node_modules/scratch-audio/src/index.js
// module id = ToHH
// module chunks = 0